import { Query } from '@/app/tracking/api';
import { BadgeState } from './badge-state'

export interface QueryBadgeStatesTrackingQueryPayload {
}

export interface QueryBadgeStatesTrackingQueryResult {
  badges: BadgeState[]
}

export const QueryBadgeStatesTrackingQueryName = 'query-badge-states' as const
export type QueryBadgeStatesTrackingQuery =
      Query<typeof QueryBadgeStatesTrackingQueryName, QueryBadgeStatesTrackingQueryPayload, QueryBadgeStatesTrackingQueryResult>
